//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import { menuToggles } from "./consts";

export default {
    components: {
        AQMenu
    },
    data() {
        return {
            error: false,
            toggles: menuToggles,
            toggleArray: [],
            modelPopover: null,
            test22: "qwerty",
            showMenu2: [],
            showMenu: [],
            testModel: [],
            errorDefaultPath: true,
            menuList: [
                {
                    label: "simple"
                },
                {
                    label: "asingleLongNameSoWeCanTestThisOneOlso"
                },
                {
                    label: "test"
                },
                {
                    label: "qwerty1"
                },
                {
                    label: "AnaAreMere"
                },
                {
                    label:
                        "last long option so we can test if ellipsis is applied"
                }
            ],
            listForSelect: [
                {
                    value: "1",
                    label: "test2131231qweryu not sol longTextafter all",
                    iconLeft: {
                        name: "supervised_user_circle",
                        color: "blue"
                    },
                    tooltipProps: {
                        tooltipContent:
                            "test2131231qweryu not sol longTextafter all",
                        direction: "left"
                    }
                },
                {
                    value: "12",
                    label: "test2",
                    avatarProps: { type: "platformManager" },
                    leftIcon: { name: "account_circle" },
                    badgeProps: {
                        badgeText: "string",
                        badgeColor: "red",
                        fontSize: 12
                    },
                    tooltipProps: {
                        tooltipContent: "other description",
                        direction: "right"
                    },
                    description: "other description long description to test"
                },
                {
                    value: "3",
                    label: "test3",
                    avatarProps: { type: "externallySetManager" },
                    leftIcon: {
                        name: "add",
                        color: "pink"
                    },
                    badgeProps: {
                        badgeType: "date"
                    },
                    tooltipProps: {
                        tooltipContent: "Some tooptip text",
                        direction: "top"
                    }
                },
                {
                    value: "4",
                    label: "test4",
                    leftIcon: { name: "add", size: "12px" },
                    rightIcon: { name: "add", size: "12px", color: "red" },
                    avatarProps: { type: "userPlatform" },
                    badgeProps: {
                        badgeText: "qwe"
                    },
                    description: "other description"
                },
                {
                    value: "5",
                    label: "qwerty1",
                    leftIcon: {},
                    avatarProps: { type: "userPlatform" }
                },
                {
                    value: "6",
                    label: "qwerty22LongTtexttoSeeWtfhappends",
                    avatarProps: { type: "externallySetManager" }
                }
            ],
            list2: [
                {
                    value: "1",
                    label: "test2131231LONGTestAndsomeMore text",
                    badgeProps: {
                        badgeText: "qwe"
                    },
                    rightIcon: { name: "add", size: "12px", color: "red" },
                    avatarProps: { type: "userPlatform" },
                    itemDisabled: true
                },
                {
                    value: "12",
                    label: "test2",
                    rightIcon: { name: "add", size: "18px", color: "blue" },
                    avatarProps: { type: "platformManager" }
                },
                {
                    value: "3",
                    label: "test3",
                    rightIcon: { name: "clear" }
                },
                {
                    value: "4",
                    label: "test4",
                    rightIcon: { name: "mdi-account-circle" },
                    avatarProps: { type: "userPlatform" },
                    chipProps: { content: "qwerty" },
                    description: "other description"
                },
                {
                    value: "5",
                    label: "qwerty1",
                    avatarProps: { type: "userPlatform" },
                    chipProps: {
                        content: "qwerty",
                        innerContent: "Class",
                        type: "m_datamodel"
                    },
                    description: "one description"
                },
                {
                    value: "6",
                    label: "qwerty22",
                    avatarProps: { type: "externallySetManager" },
                    description:
                        "one description to see how it works , and its a veryl long one too see this too"
                }
            ],
            listOnlyBadges: [
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                },
                {
                    badgeProps: { badgeText: "qwe" }
                }
            ],
            headerList: [
                {
                    value: "loan",
                    label: "Loan interface"
                },
                {
                    value: "acc",
                    label: "Acceptance structure"
                },
                {
                    value: "user",
                    label: "User Form"
                },
                {
                    value: "test",
                    label: "Test first interface"
                },
                {
                    value: "internal",
                    label: "Internal interface for loading data"
                },
                {
                    value: "data",
                    label: "User Data"
                },
                {
                    value: "account",
                    label: "Accounting Decision"
                }
            ]
        };
    },

    computed: {
        addSearch() {
            return !!this.toggleArray.find(elem => elem === "addSearch");
        },
        disable() {
            return !!this.toggleArray.find(elem => elem === "disable");
        },
        fitParentContainer() {
            return !!this.toggleArray.find(
                elem => elem === "fitParentContainer"
            );
        },
        resetSelectedData() {
            return !!this.toggleArray.find(
                elem => elem === "resetSelectedData"
            );
        },
        closeOnSelection() {
            return !!this.toggleArray.find(elem => elem === "closeOnSelection");
        },
        custom() {
            return !!this.toggleArray.find(elem => elem === "custom");
        },
        hasCheckbox() {
            return !!this.toggleArray.find(elem => elem === "hasCheckbox");
        },
        separator() {
            return !!this.toggleArray.find(elem => elem === "separator");
        },
        isMultiselect() {
            return !!this.toggleArray.find(elem => elem === "isMultiselect");
        },
        ddlFullProps() {
            return {
                options: this.menuList,
                addSearch: this.addSearch,
                disable: this.disable,
                fitParentContainer: this.fitParentContainer,
                resetSelectedData: this.resetSelectedData,
                closeOnSelection: this.closeOnSelection,
                hasCheckbox: this.hasCheckbox,
                hasAvatar: this.toggleArray.includes("hasAvatar"),
                separator: this.separator,
                error: this.toggleArray.includes("hasError"),
                isMultiselect: this.isMultiselect,
                maxWidth: "250px"
            };
        },
        ddlSelect() {
            return {
                fitParentContainer: false,
                isMultiselect: true,
                error: true,
                errorLabel: "test error label",
                options: this.listForSelect,
                addSearch: true,
                hasCheckbox: true,
                hideClearDataIcon: true
            };
        },
        ddlSelect2() {
            return {
                fitParentContainer: false,
                hasAvatar: true,
                isMultiselect: false,
                options: this.list2,
                addSearch: false,
                hideCheckbox: true,
                hideClearDataIcon: true
            };
        },
        onlyBadgeDdl() {
            return {
                fitParentContainer: false,
                options: this.listOnlyBadges,
                hideCheckbox: true
            };
        },
        headerProps() {
            return {
                options: this.headerList,
                addSearch: true,
                titleMenu: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left"
            };
        }
    },
    watch: {
        toggleArray: {
            handler() {
                this.renderMenu();
            }
        },
        immediate: true
    },
    created() {},
    mounted() {},
    methods: {
        renderMenu() {
            if (this.toggleArray.find(elem => elem === "itemDisabled")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    elem.itemDisabled = true;
                    return elem;
                });
            }
            if (this.toggleArray.find(elem => elem === "hasDescription")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    elem.description = "one long description to test ellipsis qwerety1234";
                    return elem;
                });
            }
            if (this.toggleArray.find(elem => elem === "hasAvatar")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    if (this.custom) {
                        elem.avatarProps = {
                            type: "externalGroup",
                            size: 34
                        };
                    } else {
                        elem.avatarProps = {
                            type: "platformSetManager"
                        };
                    }
                    return elem;
                });
            }
            if (this.toggleArray.find(elem => elem === "hasBadge")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    if (this.custom) {
                        elem.badgeProps = {
                            badgeText: "custom",
                            badgeColor: "pink",
                            fontSize: 12
                        };
                    } else {
                        elem.badgeProps = { badgeType: "string" };
                    }
                    return elem;
                });
            }
            if (this.toggleArray.find(elem => elem === "hasTooltip")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    elem.tooltipProps = {
                        tooltipContent: "Tooltip exemple",
                        direction: "top"
                    };
                    return elem;
                });
            }
            if (this.toggleArray.find(elem => elem === "hasChip")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    if (!this.custom) {
                        elem.chipProps = { content: "Chip" };
                    } else {
                        elem.chipProps = {
                            type: "m_datamodel",
                            content: "Chip",
                            innerContent: "Has"
                        };
                    }
                    return elem;
                });
            }
            if (this.toggleArray.find(elem => elem === "leftIcon")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    if (this.custom) {
                        elem.leftIcon = {
                            name: "edit",
                            color: "red",
                            size: "28px"
                        };
                    } else {
                        elem.leftIcon = { name: "edit" };
                    }
                    return elem;
                });
            }
            if (this.toggleArray.find(elem => elem === "rightIcon")) {
                this.menuList = this.menuList.map(item => {
                    const elem = { ...item };
                    if (this.custom) {
                        elem.rightIcon = {
                            name: "folder",
                            color: "blue",
                            size: "16px"
                        };
                    } else {
                        elem.rightIcon = { name: "folder" };
                    }
                    return elem;
                });
            }
        },
        setOnShow() {

        },
        consoleHide() {

        }
    }
};
